import { registerActivityChatCommand } from '@ayocore/activity/client/extensions';

/**
 * Команда `/deal` — привязка сделки (scope-marker).
 *
 * Inline-команда: очищает инпут и вставляет `#`. Стандартная детекция
 * в композере подхватывает trigger и открывает popup со списком сделок.
 * При выборе сделки в комментарии создаётся scope, и комментарий
 * привязывается к выбранной сделке (см. ActivityCommentScope).
 *
 * Полезно для discoverability — пользователь видит команду в slash-меню
 * и узнаёт о shortcut'е `#`.
 */
export const dealMentionActivityChatCommand = registerActivityChatCommand({
  id: 'deal_mention',
  trigger: 'deal',
  label: 'Привязать сделку',
  description: 'Вставить # и открыть список сделок',
  aliases: ['hash', 'd'],
  inlineHandler: api => api.openDealMention(),
  isAvailable: () => false,
});
